import { render, staticRenderFns } from "./ManageCustomDataFields.vue?vue&type=template&id=64f98e3e"
import script from "./ManageCustomDataFields.vue?vue&type=script&lang=js"
export * from "./ManageCustomDataFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports